
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonClosedLeft as ObiThreewayAcuatorPistonClosedLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-closed-left.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonClosedLeft = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-closed-left',
   elementClass: ObiThreewayAcuatorPistonClosedLeftElement,
   events: {
     
   }
  });
 
 